import CampaignMappingFieldResourceModel from '../../generated/types/model/resource/CampaignMappingFieldResourceModel';

export default class CampaignMappingFieldResourceViewModel extends CampaignMappingFieldResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
